"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Leadership() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: portraitsRef,
    isVisible: portraitsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const instructors = [{
    name: "Budi Santoso",
    specialty: "KETUA UMUM • PUSAT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_budi_santoso.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_budi_santoso.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_budi_santoso.webp-wvc-sizes"
  }, {
    name: "Siti Aminah",
    specialty: "SEKRETARIS • JENDERAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_siti_aminah.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_siti_aminah.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_siti_aminah.webp-wvc-sizes"
  }, {
    name: "Agus Wijaya",
    specialty: "BENDAHARA • UMUM",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_agus_wijaya.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_agus_wijaya.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_agus_wijaya.webp-wvc-sizes"
  }, {
    name: "Dewi Lestari",
    specialty: "WAKIL KETUA • OPERASIONAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_dewi_lestari.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_dewi_lestari.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_dewi_lestari.webp-wvc-sizes"
  }, {
    name: "Rahmat Hidayat",
    specialty: "WAKIL KETUA • STRATEGIS",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_rahmat_hidayat.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_rahmat_hidayat.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pimpinan_rahmat_hidayat.png-wvc-sizes"
  }];
  return <section data-section-id="251" id="organizationleadership" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[140px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-1/2 hidden md:block -translate-y-1/2">
        <div className="flex flex-col gap-3 opacity-[0.08]">
          <div className="h-px bg-foreground" />
          <div className="h-px bg-foreground" />
          <div className="h-px bg-foreground" />
          <div className="h-px bg-foreground" />
          <div className="h-px bg-foreground" />
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-10 gap-8 lg:gap-12 mb-20 md:mb-28 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-5">
            <p className="font-default text-xs uppercase tracking-[0.2em] text-primary mb-6">
              No. 01 / Pimpinan
            </p>
            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl text-foreground leading-[1.05] tracking-tight">
              Jajaran{" "}
              <span className="italic font-light" style={{
              color: "var(--secondary)"
            }}>
                Pimpinan
              </span>
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pl-8 flex flex-col justify-end">
            <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed mb-6 max-w-md">
              Para pemimpin ABADI.NEWS berkomitmen menjaga integritas jurnalistik, 
              mendorong transparansi informasi, dan memastikan setiap berita yang 
              disajikan memberikan dampak positif bagi masyarakat luas.
            </p>
            <Link to="/OrganizationStructurePage" className="group inline-flex items-center gap-2 font-default text-xs uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors duration-300 self-start">
              <span className="border-b border-foreground/40 group-hover:border-primary pb-1 transition-colors duration-300">
                Lihat Struktur
              </span>
              <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </div>

        {}
        <div ref={portraitsRef} className="grid grid-cols-2 gap-x-6 gap-y-14 md:flex md:flex-row md:justify-between md:items-start md:gap-4">
          {instructors.map((instructor, i) => <div key={i} data-index={i} className={`group flex flex-col items-center text-center md:flex-1 transition-all duration-700 ease-out ${portraitsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i % 2 === 1 ? "md:mt-8" : ""}`} style={{
          transitionDelay: portraitsVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="relative mb-6">
                <div className="absolute inset-0 rounded-lg ring-4 ring-background ring-offset-2 ring-offset-transparent transition-all duration-500 group-hover:ring-offset-4" />
                <div className="relative overflow-hidden rounded-lg transition-all duration-500 group-hover:scale-[1.03]" style={{
              boxShadow: "0 0 0 4px var(--background), 0 0 0 5px transparent"
            }}>
                  <div className="absolute -inset-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
                boxShadow: "0 0 0 2px var(--primary)",
                borderRadius: "8px"
              }} />
                  <div className="size-36 sm:size-44 md:size-44 lg:size-52 xl:size-60 rounded-lg overflow-hidden">
                    <img src={instructor.image} data-wvc-srcset={instructor.srcset} data-wvc-sizes={instructor.sizes} alt={instructor.name} loading="lazy" decoding="async" className="size-full object-cover rounded-lg transition-transform duration-700 group-hover:scale-105" style={{
                  borderRadius: "8px"
                }} />
                  </div>
                </div>
              </div>

              <h3 className="font-default text-xl md:text-[20px] text-foreground tracking-tight transition-transform duration-300 group-hover:translate-x-0.5" style={{
            fontWeight: 600
          }}>
                {instructor.name.toUpperCase()}
              </h3>
              <p className="mt-2 font-default text-[11px] md:text-[12px] uppercase tracking-[0.18em]" style={{
            color: "var(--primary)"
          }}>
                {instructor.specialty}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}